import { createApp } from 'vue'
import App from './App.vue'
import {createPinia} from 'pinia'
import router from './router'
//import setupInterceptors from './services/setupInterceptors';
import piniaPluginPersistedState from "pinia-plugin-persistedstate"

//setupInterceptors();

const pinia = createPinia()

pinia.use(piniaPluginPersistedState)

const app = createApp(App)
app.use(pinia)
app.use(router)
app.mount('#app')
